import React from 'react';
import { $ } from '../lib/ext-refs';
import { toLabel } from '../lib/utils';

class AccountsTable extends React.Component {
    constructor(props) {
        super(props);

        this.populatePaymentFields = this.populatePaymentFields.bind(this);
        this.populateSearchFields = this.populateSearchFields.bind(this);
        this.populateMultiPayFields = this.populateMultiPayFields.bind(this);
        this.handleControlButtonClick = this.handleControlButtonClick.bind(this);
        this.populateCustomerInfoFields = this.populateCustomerInfoFields.bind(this);

        //overide to customize cols
        this.getHeaderRow = this.getHeaderRow.bind(this);
        this.getColumnMappings = this.getColumnMappings.bind(this);
        this.getAdditionalTableOptions = this.getAdditionalTableOptions.bind(this);
    }

    componentDidMount() {
        const { state } = this.props
        const { config } = state;
        const { clientConfig, messages } = config;
        const { multiPayEnabled, multiPayMaxNrAccounts, iapAccountMappingKeyType, iapSsoAccountsEnabled, iapSummaryWidgetEnabled,iapHideSearchOption} = clientConfig;

        const self = this;

        if (!iapHideSearchOption){
            $('#accounts-table thead tr').clone(true).appendTo('#accounts-table thead');
            $('#accounts-table thead tr:eq(1) th').each(function (i) {
                let title = $(this).text();
                $(this).html('<input type="text" style="width:100%" placeholder="Search ' + title + '" />');

                $('input', this).on('keyup change', function () {
                    if (table.column(i).search() !== this.value) {
                        table
                            .column(i)
                            .search(this.value)
                            .draw();
                    }
                });
            });
        };

        $.fn.dataTable.moment(config.dateFormat);
        let table ;
        if (iapSsoAccountsEnabled){
            let accountsArray=[];
            if (config.accounts && config.accounts.length > 0 ){
                config.accounts.forEach(account =>{
                    accountsArray.push(account.header);
                })
            }
            let additionalTableOptions= this.getAdditionalTableOptions();
            table = $('#accounts-table').DataTable({
                    ...{
                        orderCellsTop: true,
                        //            fixedHeader: true,
                        scrollX: true,
                        stateSave: config.saveDatatableState,
                        stateDuration: -1,
                        stateLoaded: function (settings, data) {
                            let colCount = 0;
                            $('#accounts-table thead tr:eq(1) th input').each(function (i) {
                                $(this).val(data.columns[colCount++].search.search);
                            });
                        },
                        "data": accountsArray,
                        "columns": this.getColumnMappings(),
                        "createdRow": function (row, data, dataIndex) {
                            if (config.accounts && config.accounts.length == 1) {
                            $(row).addClass('selected');
                            }
                        }
                    },
                    ... additionalTableOptions
            });
            state.setValue('selectedAccounts', table.rows('.selected').data());
        }
        else{
            table = $('#accounts-table').DataTable({
                orderCellsTop: true,
                //            fixedHeader: true,
                scrollX: true,
                stateSave: config.saveDatatableState,
                stateDuration: -1,
                stateLoaded: function (settings, data) {
                    let colCount = 0;
                    $('#accounts-table thead tr:eq(1) th input').each(function (i) {
                        $(this).val(data.columns[colCount++].search.search);
                    });
                },
                'ajax': {
                    'url': `/iap-service/${config.tla}/accounts?JWT_TOKEN=${config.nginxJwtToken}`,
                    'type': 'GET',
                    'beforeSend': function (request) {
                        request.setRequestHeader(iapAccountMappingKeyType, config.iapAccountMappingKey);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        alert(messages["iap.accounts.load.error"]);
                    }
                },
                "columns": this.getColumnMappings(),
            });
        }
        
        $('#accounts-table tbody').on('click', 'tr', function () {
            const isSelected = $(this).hasClass('selected');
            const selectedRows = table.rows('.selected');

            if (isSelected) {
                $(this).removeClass('selected');
            } else {
                if (multiPayEnabled) {
                    if (selectedRows.data().length >= multiPayMaxNrAccounts) {
                        return alert(messages['iap.max.accounts.selected']);
                    }
                } else {
                    selectedRows.nodes().to$().removeClass('selected');//deselect all from all pages
                }
                $(this).addClass('selected');
            }
            state.setValue('selectedAccounts', table.rows('.selected').data());
        });

    }

    render() {
        const { state, appComponents } = this.props;
        const { config, data } = state;
        const { clientConfig, agentAccess } = config;
        const { multiPayEnabled, multiPayMaxNrAccounts } = clientConfig;
        const displaySummaryWidget = clientConfig.iapSummaryWidgetEnabled;
        const { LiabilitySummaryWidget } = this.props.appComponents;

        let multiPayFieldsets = [];
        if (multiPayEnabled) {
            for (let i = 0; i < multiPayMaxNrAccounts; i++) {
                multiPayFieldsets.push(
                    <fieldset>
                        <input type="hidden" value="" name={`paymentIndexed[${i}].header.active`} ></input>
                        <input type="hidden" value="" name={`paymentIndexed[${i}].header.paymentTypeId`} ></input>
                        <input type="hidden" value="" name={`paymentIndexed[${i}].header.paymentTypeCode`} ></input>
                        <input type="hidden" value="" name={`paymentIndexed[${i}].header.accountNumber`} ></input>
                        <input type="hidden" value="" name={`paymentIndexed[${i}].header.authToken1`} ></input>
                        <input type="hidden" value="" name={`paymentIndexed[${i}].header.authToken2`} ></input>
                        <input type="hidden" value="" name={`paymentIndexed[${i}].header.authToken3`} ></input>
                    </fieldset>
                )
            }
        }

        return (
            <div className="accounts-table-wrapper" >
                <ControlButtons state={state} handleControlButtonClick={this.handleControlButtonClick} />
                <table id="accounts-table" className="display">
                    <thead>
                        {this.getHeaderRow()}
                    </thead>
                </table>
                <div>
                    {   displaySummaryWidget && 
                        data.selectedAccounts && 
                        data.selectedAccounts.length === 1 && 
                        <LiabilitySummaryWidget state={state} appComponents={appComponents}/>
                    }
                </div>
                <form method="post" action="#" name="IapActionForm">
                    <input type="hidden" value="iap" name="RQ_ENTRY_POINT" />
                    <input type="hidden" value={state.config.csrf} name="CSRF_TOKEN" ></input>

                    {/* SEARCH */}
                    <input type="hidden" value="" name="accountNumber" ></input>
                    <input type="hidden" value="" name="paymentTypeId" ></input>
                    <input type="hidden" value="" name="operation" ></input>

                    {/* OTP */}
                    <input type="hidden" value="" name="header.paymentTypeCode" ></input>
                    <input type="hidden" value="" name="header.paymentTypeId" ></input>
                    <input type="hidden" value="" name="header.accountNumber" ></input>

                    {/* AUTH TOKENS */}
                    <input type="hidden" value="" name="customer.address.zipCode"></input>
                    <input type="hidden" value="" name="header.accountToken"></input>
                    <input type="hidden" value="" name="customer.dayPhone.npa"></input>
                    <input type="hidden" value="" name="customer.dayPhone.nxx"></input>
                    <input type="hidden" value="" name="customer.dayPhone.did"></input>
                    <input type="hidden" value="" name="customer.dayPhone.ext"></input>

                    {/* CX INFO */}
                    {clientConfig.iapPopulateCustomerInfo && (
                        <fieldset>
                            <input type="hidden" value="" name="customer.firstName"></input>
                            <input type="hidden" value="" name="customer.middleName"></input>
                            <input type="hidden" value="" name="customer.lastName"></input>
                            <input type="hidden" value="" name="customer.email"></input>
                            <input type="hidden" value="" name="customer.email2"></input>
                        </fieldset>)}

                    {/* MULTI PAY */}
                    {multiPayFieldsets}
                </form>
            </div >
        )
    }

    getPaymentTypeId = (ptCode) => {
        const { state } = this.props
        const { config } = state;
        const paymentTypes = config.paymentTypes || {};
        return paymentTypes[ptCode] ? paymentTypes[ptCode].id : 0;
    }

    getPaymentTypeDescription = (ptCode) => {
        const { state } = this.props
        const { config } = state;
        const paymentTypes = config.paymentTypes || {};
        return paymentTypes[ptCode] ? paymentTypes[ptCode].description : ptCode;
    }

    //biller can customize following 2 methods
    getColumnMappings() {
        const { state, appComponents } = this.props,
            { formatAccountNumber } = appComponents;
        const { config } = state;
        const { clientConfig } = config;
        const { displayAuthToken1, displayAuthToken2, displayAuthToken3 } = clientConfig;
        const { liabilityToken1Config, liabilityToken2Config, liabilityToken3Config } = clientConfig;

        const displayAuthToken = (config, data) => {
            if (config != 'DAY_PHONE') {
                return data;
            }
            if (!!data && data.length >= 10) {
                return `(${data.substring(0, 3)}) ${data.substring(3, 6)}-${data.substring(6, 10)}` + (data.length >= 12 ? ` ext. ${data.substring(12)}` : '');
            }
            return "";
        }

        let columns = [
            {
                data: "paymentTypeDesc",
                defaultContent: "",
                render: (data, type, row) => {
                    return data || row.paymentTypeDescription  || this.getPaymentTypeDescription(row.paymentTypeCode);
                }
            },
            {
                data: "accountNumber",
                defaultContent: "",
                render: (data, type, row) => {
                    return formatAccountNumber(data, row.paymentTypeCode, clientConfig);
                }
            },
        ]
        if (displayAuthToken1) {
            columns.push({
                data: "authToken1",
                defaultContent: "",
                render: (data, type, row) => {
                    return displayAuthToken(liabilityToken1Config, data);
                }
            });
        }
        if (displayAuthToken2) {
            columns.push({
                data: "authToken2",
                defaultContent: "",
                render: (data, type, row) => {
                    return displayAuthToken(liabilityToken2Config, data);
                }
            });
        }
        if (displayAuthToken3) {
            columns.push({
                data: "authToken3",
                defaultContent: "",
                render: (data, type, row) => {
                    return displayAuthToken(liabilityToken3Config, data);
                }
            });
        }

        return columns;
    }

    getHeaderRow() {
        const { state } = this.props;
        const { clientConfig, messages } = state.config;
        const { displayAuthToken1, displayAuthToken2, displayAuthToken3 } = clientConfig;

        return (
            <tr>
                <th>{messages["payment.type.label"]}</th>
                <th>{messages["payment.account.label"]}</th>
                {displayAuthToken1 && (<th>{toLabel(messages["otp.authToken1.label"])}</th>)}
                {displayAuthToken2 && (<th>{toLabel(messages["otp.authToken2.label"])}</th>)}
                {displayAuthToken3 && (<th>{toLabel(messages["otp.authToken3.label"])}</th>)}
            </tr>
        );
    }

    //override custom files to add data table options
    getAdditionalTableOptions(){
        return {};
    }

    handleControlButtonClick(button) {
        const { state } = this.props;
        const { config } = state;
        const { adUrls } = config;
        const { data } = state;
        const selectedAccounts = data.selectedAccounts || [];
        const multiSelectActions = ['make-payment'];

        if (!selectedAccounts.length) {
            return alert(messages['iap.select.account.message'] || 'Please select an account first');
        }

        if (multiSelectActions.indexOf(button) < 0 && selectedAccounts.length > 1) {
            return alert(messages['iap.select.one.account.message'] || 'Please select one account to proceed');
        }

        $('#spinnerOverlay').show();
        state.setValue('disableControlButtons', true);

        let form = document.IapActionForm;
        switch (button) {
            case 'make-payment':
                if (selectedAccounts.length > 1) {
                    this.populateMultiPayFields(adUrls['make-payment-multi'] || 'iap-mp-init.do?newBean=true');
                } else {
                    this.populatePaymentFields(adUrls[button] || 'iap-cxinfo.do?newBean=true')
                }
                break;
            case 'schedule-payment':
                this.populatePaymentFields(adUrls[button] || 'iap-lif-schedule-cxinfo.do?newBean=true');
                break;
            case 'search-payments':
                this.populateSearchFields(adUrls[button] || 'payment-search.do?clearBean=true');
                break;
            case 'search-schedules':
                this.populateSearchFields(adUrls[button] || 'schedule-search.do?clearBean=true');
                break;
            case 'customer-wallet':
                this.populateSearchFields(adUrls[button] || 'wallet-customer-search.do');
                break;
        }
        form.submit();
    }

    populateCustomerInfoFields(account) {
        if (!account) {
            return;
        }

        let form = document.IapActionForm;
        const { firstName, middleName, lastName, email, dayPhone } = account;

        if (firstName) {
            form['customer.firstName'].value = firstName;
        }
        if (middleName) {
            form['customer.middleName'].value = middleName;
        }
        if (lastName) {
            form['customer.lastName'].value = lastName;
        }
        if (email) {
            form['customer.email'].value = email;
            form['customer.email2'].value = email2;
        }
        if (dayPhone && dayPhone.length >= 10) {
            form['customer.dayPhone.npa'].value = dayPhone.substring(0, 3);
            form['customer.dayPhone.nxx'].value = dayPhone.substring(3, 6);
            form['customer.dayPhone.did'].value = dayPhone.substring(6, 10);
            if (account.dayPhone.length >= 12) {
                form['customer.dayPhone.ext'].value = dayPhone.substring(12);
            }
        }
    }

    populateSearchFields(action) {
        const { data } = this.props.state;
        const selectedAccounts = data.selectedAccounts || [];
        let account = selectedAccounts[0];

        let form = document.IapActionForm;
        form.accountNumber.value = account.accountNumber
        form.paymentTypeId.value = account.paymentTypeId
        form.operation.value = 'search'
        form.action = action;
    }

    populateMultiPayFields(action) {
        const { config, data } = this.props.state;
        const selectedAccounts = data.selectedAccounts || [];
        const { clientConfig } = config;
        const { liabilityToken1Enabled, liabilityToken2Enabled, liabilityToken3Enabled } = clientConfig;

        let form = document.IapActionForm;
        for (let i = 0; i < selectedAccounts.length; i++) {
            const { paymentTypeId, paymentTypeCode, accountNumber, authToken1, authToken2, authToken3 } = selectedAccounts[i];
            form[`paymentIndexed[${i}].header.active`].value = true;
            form[`paymentIndexed[${i}].header.paymentTypeCode`].value = paymentTypeCode;
            form[`paymentIndexed[${i}].header.paymentTypeId`].value = paymentTypeId || this.getPaymentTypeId(paymentTypeCode);
            form[`paymentIndexed[${i}].header.accountNumber`].value = accountNumber;
            if (liabilityToken1Enabled) {
                form[`paymentIndexed[${i}].header.authToken1`].value = authToken1;
            }
            if (liabilityToken2Enabled) {
                form[`paymentIndexed[${i}].header.authToken2`].value = authToken2;
            }
            if (liabilityToken3Enabled) {
                form[`paymentIndexed[${i}].header.authToken3`].value = authToken3;
            }
        }
        if (clientConfig.iapPopulateCustomerInfo) {
            this.populateCustomerInfoFields(selectedAccounts[0]);
        }
        form.action = action
    }

    populatePaymentFields(action) {
        const { config, data } = this.props.state;
        const selectedAccounts = data.selectedAccounts || [];
        const { clientConfig } = config;
        const { liabilityToken1Config, liabilityToken2Config, liabilityToken3Config } = clientConfig;
        const { liabilityToken1Enabled, liabilityToken2Enabled, liabilityToken3Enabled } = clientConfig;
        const { liabilityToken1Input, liabilityToken2Input, liabilityToken3Input } = clientConfig;

        const addAuthTokenField = (config, input, value) => {
            let form = document.IapActionForm;
            if (config == 'DAY_PHONE') {
                if (value && value.length >= 10) {
                    form[`${input}.npa`].value = value.substring(0, 3);
                    form[`${input}.nxx`].value = value.substring(3, 6);
                    form[`${input}.did`].value = value.substring(6, 10);
                    if (value.length >= 12) {
                        form[`${input}.ext`].value = value.substring(12);
                    }
                }
            } else {
                form[input].value = value;
            }
        }

        let form = document.IapActionForm;
        let account = selectedAccounts[0];
        form['header.paymentTypeCode'].value = account.paymentTypeCode;
        form['header.paymentTypeId'].value = account.paymentTypeId || this.getPaymentTypeId(account.paymentTypeCode);
        form['header.accountNumber'].value = account.accountNumber;
        if (liabilityToken1Enabled) {
            addAuthTokenField(liabilityToken1Config, liabilityToken1Input, account.authToken1)
        }
        if (liabilityToken2Enabled) {
            addAuthTokenField(liabilityToken2Config, liabilityToken2Input, account.authToken2)
        }
        if (liabilityToken3Enabled) {
            addAuthTokenField(liabilityToken3Config, liabilityToken3Input, account.authToken3)
        }
        if (clientConfig.iapPopulateCustomerInfo) {
            this.populateCustomerInfoFields(account);
        }
        form.action = action
    }
}

const ControlButtons = ({ state, handleControlButtonClick }) => {
    const { config, data } = state;
    const disableControlButtons = data.disableControlButtons || false;
    const { messages, agentAccess, clientConfig } = config;
    const btnClass = 'actionbutton';

    return (
        <div id="control-menu">
            <h2>{messages['accounts.tabTitle']}</h2>
            <div class="actions">
               {agentAccess.customerWallet &&  (<button
                    type="button"
                    className={btnClass + " btn-customer-wallet"}
                    onClick={() => handleControlButtonClick('customer-wallet')}
                    disabled={disableControlButtons}
                >{messages['iap.customer.wallet'] }
                </button>)}
                {agentAccess.makePayments && (<button
                    type="button"
                    className={btnClass + " btn-make-payment"}
                    onClick={() => handleControlButtonClick('make-payment')}
                    disabled={disableControlButtons}
                >{messages['iap.make.payment']}
                </button>)}
                {agentAccess.schedulePayments && (<button
                    type="button"
                    onClick={() => handleControlButtonClick('schedule-payment')}
                    className={btnClass + " btn-schedule-payment"}
                    disabled={disableControlButtons}
                >{messages['iap.schedule.payment']}
                </button>)}
                {agentAccess.searchPayments && (<button
                    type="button"
                    onClick={() => handleControlButtonClick('search-payments')}
                    className={btnClass + " btn-search-payments"}
                    disabled={disableControlButtons}
                >{messages['iap.search.payments']}
                </button>)}
                {agentAccess.searchSchedules && (<button
                    type="button"
                    onClick={() => handleControlButtonClick('search-schedules')}
                    className={btnClass + " btn-search-schedules"}
                    disabled={disableControlButtons}
                >{messages['iap.search.schedules']}
                </button>)}
            </div>
        </div>
    );
};


export {
    AccountsTable,
    ControlButtons
} 